import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './icon_button.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Link from './basic/link'

function IconButton(props) {
	const fields = props.fields
	const button = fields.link
	const icon = fields.icon

	console.log(fields);

	return <div>
		<ScrollAnimation styles={styles}>
			<BlockWrapper {...props} className={classNames(styles.icon_cards, styles[fields.style])}>
				<Link href={button.url} target={button.target} className={styles.link}>
					<div className={styles.icon_button}>
						{icon && <Image className={styles.icon} {...icon} />}
						{button && <p className={styles.title}>{button.title}</p>}
					</div>
				</Link>
			</BlockWrapper>
		</ScrollAnimation>
	</div>
}

export default IconButton;